export interface WindowScopeInterface {
    Bod: HTMLElement | null;
    app: any; // Will be typed properly when set
    closeMobNav: any;
    openSearch: any;
    enableAutocomplete: Function;
    detailBreadcrumbModifier: any;
    resetBody: any;
}

export const windowScope: WindowScopeInterface = {
    Bod: null, // Will be set when DOM is ready
    app: null, // Will be set when app initializes
    closeMobNav: null,
    openSearch: null,
    enableAutocomplete: Function,
    detailBreadcrumbModifier: null,
    resetBody: null
};

// Expose to window for global access
declare global {
    interface Window {
        windowScope: WindowScopeInterface;
    }
}

// Make it available globally
(window as any).windowScope = windowScope;
